import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import '../../../../assets/nascent.css';

import Common from "../../../../helper/common";
import {
    FormikInput, FormikSearchSelect, FormikSingleFileUpload, FormikSelect,
    FormikSwitch
} from "../../../../components/formik-components";
import { respEnum, DateTimeminFormat } from "../../../../constants/appConstant";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const FormikInitialValues = {isactive:true};
const formikValidation = yup.object({
    name: yup.string().trim().min(3).max(100).required("Name is Required"),
    sportId: yup.number().required("Sport is required"),
    organizerName: yup.string().required("Organizer Name is required"),
    startDateTime: yup
        .date()
        .test(
            "is-valid-time",
            "Time of the start date format should be in 00, 30 or 23:59 format",
            (value) => Common.Utility.checkValidTimeOfDate(value)
        ),
    endDateTime: yup
        .date()
        .test(
            "is-valid-time",
            "Time of the end date format should be in 00, 30 or 23:59 format",
            (value) => Common.Utility.checkValidTimeOfDate(value)
        ),
});

const AddMasterTournament = ({ id, onClose, open, setOpen }) => {
    const formikRef = useRef();
    const dialogRef = useRef();
    const [sports, setSports] = useState([]);
    const navigate = useNavigate();
    const [isFormikInitialized, setIsFormikInitialized] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            GetSports();
        };
        fetchData();
    }, []);

    useEffect(() => {
        setIsFormikInitialized(open);
    }, [open]);

    const GetSports = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetSports"
            );
            const data = [
                { id: null, name: "Select Sport" },
                ...(response?.data ?? []),
            ];

            setSports(data);
        });
    };


    const onSubmitData = async (d, action) => {

        //if (!d.files && !d.icon) {
        //    Common.SweetAlert.alert('Select Icon ', 'error')
        //    return;
        //}
        if (d.files && d.files.filter((item) => !item.imageUrl).length) {
            d.icon = (await Common.Utility.handleFileUpload(d.files))[0].photo;
            d.files = null;
        }
        let data = {
            ...d,
            id,
        };
        let response = await Common.ApiService.getInstance().request(
            "AddUpdateMasterTournaments",
            data,
            "POST"
        );
        action.setSubmitting(false);
        if (response.status === respEnum.Success) {
            onClose(response.data);
            setOpen(false);
            if (!onClose) {
                navigate("/app/MasterTournaments", { replace: true });
            }
        }
    };

    const getDataInfo = async () => {
        debugger
        let response = await Common.ApiService.getInstance().request(
            `GetMasterTournaments?id=${id}`
        );
        if (response.status === respEnum.Success && response.data.length > 0) {
            const d = response?.data?.[0];
            if (d.startDatetime)
                d.startDateTime = moment(d.startDatetime).format(DateTimeminFormat); 

            if (d.endDatetime)
                d.endDateTime = moment(d.endDatetime).format(DateTimeminFormat); 

            formikRef.current.setValues(d);
        }
    };

    useEffect(() => {
        if (id) {
            getDataInfo();
        }
    }, [id]);

    return (
        <div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    <Button
                        size="sm"
                        variant="primary"
                        className="flex items-center gap-2"
                    >
                        <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
                        Add
                    </Button>
                </DialogTrigger>
                <DialogContent className="custom-modal">
                
                    <DialogHeader>
                        <DialogTitle>{id ? "Update" : "Add"} Master Tournament</DialogTitle>
                    </DialogHeader>

                    <div className="text-sm text-default-500 space-y-2 mb-3">
                        <Formik
                            innerRef={formikRef}
                            onSubmit={onSubmitData}
                            initialValues={FormikInitialValues}
                            validationSchema={formikValidation}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {(formikProps) => (
                                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                                    <div className="col-span-1">
                                        <div className="md:grid md:grid-cols-2 gap-4 mt-6">
                                            {/* Left Column - All Fields except Icon */}
                                            <div className="flex flex-col gap-3">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"name"}
                                                    label={"Name"}
                                                    placeholder={"Name"}
                                                    maxLength="100"
                                                />

                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"organizerName"}
                                                    label={"Organizer Name"}
                                                    placeholder={"Organizer Name"}
                                                    maxLength="30"
                                                />

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <FormikInput
                                                        formikProps={formikProps}
                                                        name={"organizerPhoneNo"}
                                                        label={"Organizer Phone No"}
                                                        placeholder={"Organizer Phone No"}
                                                        maxLength="30"
                                                    />

                                                    <FormikSearchSelect
                                                        formikProps={formikProps}
                                                        name={"sportId"}
                                                        data={sports}
                                                        placeholder={"Select Sport"}
                                                        label={"Sport"}
                                                    />

                                                    <FormikInput
                                                        formikProps={formikProps}
                                                        name={"startDateTime"}
                                                        placeholder={""}
                                                        label={"Start Date"}
                                                        type={"datetime-local"}
                                                    />

                                                    <FormikInput
                                                        formikProps={formikProps}
                                                        name={"endDateTime"}
                                                        placeholder={""}
                                                        label={"End Date"}
                                                        type={"datetime-local"}
                                                        min={
                                                            formikProps.values.startDateTime 
                                                        }
                                                    />


                                                    <FormikSwitch
                                                        formikProps={formikProps}
                                                        name={"isactive"}
                                                        label={"Is Active"}
                                                    />
                                                </div>

                                                

                                                
                                            </div>

                                            {/* Right Column - Icon Upload */}
                                            <div className="flex flex-col gap-3">
                                                <FormikSingleFileUpload
                                                    formikProps={formikProps}
                                                    uploadMainTxt="Upload Icon"
                                                    uploadTxt="Max size 2mb"
                                                    name="icon"
                                                    maxFileUploadSize={2}
                                                />
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                    <DialogFooter className="mt-8 gap-2">
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Close
                            </Button>
                        </DialogClose>

                        {isFormikInitialized && formikRef.current && (
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikRef.current?.handleSubmit();
                                }}
                            >
                                {formikRef.current.isSubmitting
                                    ? "Saving..."
                                    : !id
                                        ? "Add"
                                        : "Update"}
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddMasterTournament;
